import { render, staticRenderFns } from "./ConfigurationProjectTeam.vue?vue&type=template&id=966b2414&scoped=true"
import script from "./ConfigurationProjectTeam.vue?vue&type=script&lang=js"
export * from "./ConfigurationProjectTeam.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationProjectTeam.vue?vue&type=style&index=0&id=966b2414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966b2414",
  null
  
)

export default component.exports